import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from '../../../context/AppContext.js';
import LoadingScreen from "../../../componente/aguarde/index.jsx";
import Impressora from "../../../assets/Impressora.png";
import ImgXLS from "../../../assets/XLS.png";
import * as XLSX from 'xlsx';

function RelCheckList() {
    const { DateTime } = require("luxon");
    const [abusca, setabusca] = useState("");
    const [lista, setlista] = useState([]);
    const [loading, setLoading] = useState(false);
    const [edtativo, setedtativo] = useState("T");
    const [edtverifica, setedtverifica] = useState("T");
    const [observacao, setObservacao] = useState("");
    const [justificativa, setJustificativa] = useState("");

    const { selectedCompany, accessKey, codassinante } = useAppContext(); 

    // Função para calcular o primeiro dia do mês
    const getFirstDayOfMonth = () => {
        const dt = new Date();
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-01`;
    };

    // Função para calcular a data atual
    const getCurrentDate = () => {
        const dt = new Date();
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-${dt.getDate().toString().padStart(2, "0")}`;
    };

    const [dt1, setdt1] = useState(getFirstDayOfMonth);
    const [dt2, setdt2] = useState(getCurrentDate);

    function ListarTarefa() {
        api
            .get("/v1/relatorio/checklist", {
                params: {
                    codempresa: selectedCompany,
                    codassinante,
                    dt1,
                    dt2,
                    tipo: edtativo,
                    verifica: edtverifica,
                    observacao,
                    justificativa,
                    busca: abusca
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarTarefa();
        },
        [selectedCompany, dt1, dt2, edtativo, edtverifica, observacao, justificativa, abusca]
    );

    const imprimir = async () => {
        setLoading(true);

        try {
            const response = await api.get(`/v1/impressoes/relatorio/checklist`, {
                responseType: "arraybuffer",
                params: {
                    codempresa: selectedCompany,
                    codassinante,
                    dt1,
                    dt2,
                    tipo: edtativo,
                    observacao,
                    justificativa
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.click();
        } catch (error) {
            console.log("ops! ocorreu um erro: " + error);
        } finally {
            setLoading(false);
        }
    };

    const exportToExcel = () => {
        // Cria uma nova planilha a partir dos dados da tabela
        const worksheet = XLSX.utils.json_to_sheet(lista);

        // Cria uma nova pasta de trabalho e adiciona a planilha
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Exporta o arquivo Excel com o nome especificado
        XLSX.writeFile(workbook, `relsaldoponto.xlsx`);
    };

    const handleObservacaoChange = () => {
        setObservacao((prev) => !prev);
    };

    const handleJustificativaChange = () => {
        setJustificativa((prev) => !prev);
    };

    function FormataDataHora(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy HH:mm:ss")
            : null;
    }

    function FormataData(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy")
            : null;
    }

    return (
        <>
            <div className="app-container">
                <div className="container-fluid">
                    <div className="row">
                        <h1 className="ms-4">Relatório de CheckList</h1>
                        <p className="ms-4">Relatório das tarefas que foram registrados na empresa</p>
                        <hr />
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <label className="form-label" htmlFor="busca">
                                Busque aqui
                            </label>
                            <input
                                type="text"
                                placeholder="Buscar por: Nome do gestor ou profissional"
                                name="busca"
                                id="busca"
                                className="form-control me-3"
                                value={abusca}
                                onChange={(e) => setabusca(e.target.value)}
                            />
                        </div>

                        <div className="col-2">
                            <label htmlFor="dt1" className="form-label">
                                Tarefas de...
                            </label>
                            <input
                                type="date"
                                id="dt1"
                                className="form-control"
                                placeholder="Dt. Lançamento"
                                value={dt1}
                                onChange={(e) => setdt1(e.target.value)}
                            />
                        </div>

                        <div className="col-2">
                            <label htmlFor="dt2" className="form-label">
                                Para...
                            </label>
                            <input
                                type="date"
                                id="dt2"
                                className="form-control"
                                placeholder="Dt. Lançamento"
                                value={dt2}
                                onChange={(e) => setdt2(e.target.value)}
                            />
                        </div>

                        <div className="col-2 d-flex justify-content-end">
                            <div className="d-flex justify-content-center">
                                <button className="btn" onClick={exportToExcel}>
                                    <img src={ImgXLS} alt="XLS" />
                                    <label>Excel</label>
                                </button>
                                {loading && <LoadingScreen />}
                            </div>

                            <div className="d-flex justify-content-center">
                                <button className="btn" onClick={imprimir}>
                                    <img src={Impressora} alt="Imprimir" />
                                    <label>Imprimir</label>
                                </button>
                                {loading && <LoadingScreen />}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-3">
                            <label htmlFor="ativo1" className="form-label">
                                Tipo de Terefa
                            </label>
                            <br />
                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    id="ativo1"
                                    type="radio"
                                    name="ativo"
                                    value="T"
                                    onChange={(e) => setedtativo(e.target.value)}
                                    checked={edtativo === "T"}
                                />
                                <label className="form-check-label">Todos</label>
                            </div>

                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="ativo"
                                    value="F"
                                    onChange={(e) => setedtativo(e.target.value)}
                                    checked={edtativo === "F"}
                                />
                                <label className="form-check-label">Feito</label>
                            </div>

                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="ativo"
                                    value="P"
                                    onChange={(e) => setedtativo(e.target.value)}
                                    checked={edtativo === "P"}
                                />
                                <label className="form-check-label">Pendente</label>
                            </div>                            
                        </div>

                        <div className="col-sm-3">
                            <label htmlFor="edtverifica1" className="form-label">
                                Tarefa Verificada
                            </label>
                            <br />
                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    id="edtverifica1"
                                    type="radio"
                                    name="edtverifica"
                                    value="T"
                                    onChange={(e) => setedtverifica(e.target.value)}
                                    checked={edtverifica === "T"}
                                />
                                <label className="form-check-label">Todos</label>
                            </div>                            

                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="edtverifica"
                                    value="N"
                                    onChange={(e) => setedtverifica(e.target.value)}
                                    checked={edtverifica === "N"}
                                />
                                <label className="form-check-label">Não Concluído</label>
                            </div>

                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="edtverifica"
                                    value="S"
                                    onChange={(e) => setedtverifica(e.target.value)}
                                    checked={edtverifica === "S"}
                                />
                                <label className="form-check-label">Concluído</label>
                            </div>
                        </div>

                        <div className="col-2">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="comObservacao"
                                    onChange={handleObservacaoChange}
                                    checked={observacao}
                                />
                                <label className="form-check-label" htmlFor="comObservacao">
                                    Com Observação
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="comJustificativa"
                                    onChange={handleJustificativaChange}
                                    checked={justificativa}
                                />
                                <label className="form-check-label" htmlFor="comJustificativa">
                                    Com Justificativa
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <hr />
                    </div>

                    <div className="row">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Dt. Tarefa</th>
                                    <th>Dt. Feito</th>
                                    <th>Dt. Conclusão</th>
                                    <th>Gestor</th>
                                    <th>Profissional</th>
                                    <th>Tarefa</th>
                                    <th>Observação</th>
                                    <th>Justificatica</th>
                                    <th>Qualificação</th>
                                    <th>Coins</th>
                                    <th>Coins Efetivado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lista.map(function (item, index) {
                                    return (
                                        <tr key={index}>
                                            <th>{FormataData(item.dttarefa)}</th>
                                            <th>{FormataDataHora(item.dttarefafeito)}</th>
                                            <th>{FormataDataHora(item.dtconclusao)}</th>
                                            <th>{item.gestor}</th>
                                            <th>{item.colaborador}</th>
                                            <th>{item.tarefa}</th>
                                            <th>{item.observacao}</th>
                                            <th>{item.justificativa}</th>
                                            <th className="text-center">{item.qualificacao}</th>
                                            <th className="text-center">{item.coinssomar}</th>
                                            <th className="text-center">{item.coinsefetivado}</th>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan={11}>Quantidade de Registros: {lista.length}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RelCheckList;
